import { render, staticRenderFns } from "./GroupsCreation.vue?vue&type=template&id=57253120&scoped=true&"
import script from "./GroupsCreation.vue?vue&type=script&lang=ts&"
export * from "./GroupsCreation.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsCreation.vue?vue&type=style&index=0&id=57253120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57253120",
  null
  
)

export default component.exports